/**
 * VELKSIA — les pastilles flottantes ne couvrent plus les boutons d'achat.
 *
 * Mesure faite sur le site rendu a 390 x 750 px, le 12/09/2026 :
 *
 *   . page panier   — bouton « Payer » de x 16 a 365 ; la pastille « -5 % »
 *                     occupait 16 -> 124 et la bulle de chat 276 -> 361, a la
 *                     meme hauteur. 193 px sur 349 etaient sous un calque.
 *   . fiche produit — le bouton de la barre d'achat collante va de 318 a 370 ;
 *                     la bulle de chat en recouvrait 43 px sur 52.
 *
 * Un pouce qui visait le bouton ouvrait donc le pop-up promo ou le chat.
 *
 * Ce script releve les deux pastilles de 64 px des qu'un bouton d'achat passe
 * dessous, et les efface si le relevement ne suffit pas. Tout se joue en style
 * en ligne marque !important : les deux widgets viennent d'applications
 * tierces, et la bulle de chat porte une animation d'appel (« nudge-bounce »)
 * qui, sans cette priorite, reprendrait la main sur le deplacement.
 *
 * Au-dessus de 749 px de large, rien n'est touche : le probleme n'existe pas.
 */
(function () {
  var LARGEUR_MAX = 749; /* au-dela, l'ecran est assez large */
  var RELEVEMENT = 64; /* px dont on remonte les pastilles */
  var MARGE = 4; /* px de tolerance sur le chevauchement */
  var RETOUR = 500; /* ms avant de redescendre, pour eviter le clignotement */

  /*
    Les boutons a proteger. On exclut volontairement les ajouts rapides des
    pages collection : ils sont nombreux et feraient sautiller les pastilles
    pendant tout le defilement, pour un bouton qui n'est pas l'acte d'achat.
  */
  var BOUTONS = [
    '.sticky-add-to-cart__bar[data-stuck="true"]',
    '.cart__checkout-button',
    '.product-form-buttons .add-to-cart-button'
  ].join(',');

  var etat = -1; /* -1 inconnu, 0 en place, 1 releve, 2 efface */
  var minuteur = null;
  var planifie = false;

  function pastille() {
    return document.querySelector('.velksia-sendwill-gift');
  }

  /*
    La bulle de chat vit dans un shadow DOM dont les classes appartiennent a
    l'application. Plutot que de viser un nom de classe qui peut changer, on
    cherche le seul element positionne de petite taille : c'est le bouton.
  */
  function bulleChat() {
    var h = document.querySelector('shopify-chat');
    if (!h || !h.shadowRoot) return null;
    var els = h.shadowRoot.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var cs = window.getComputedStyle(els[i]);
      if (cs.position !== 'fixed' && cs.position !== 'absolute') continue;
      var r = els[i].getBoundingClientRect();
      if (r.width > 0 && r.width < 260 && r.height > 0 && r.height < 130) return els[i];
    }
    return null;
  }

  function chevauche(a, b) {
    if (a.right <= b.left + MARGE) return false;
    if (a.left >= b.right - MARGE) return false;
    if (a.bottom <= b.top + MARGE) return false;
    if (a.top >= b.bottom - MARGE) return false;
    return true;
  }

  function boutonsVisibles() {
    var haut = window.innerHeight;
    var els = document.querySelectorAll(BOUTONS);
    var out = [];
    for (var i = 0; i < els.length; i++) {
      if (els[i].closest('.quick-add, quick-add-component, .quick-add-modal')) continue;
      var r = els[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < haut) out.push(r);
    }
    return out;
  }

  /* Position de repos d'une pastille : on annule le relevement deja applique. */
  function auRepos(el, deja) {
    var r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return null;
    return { left: r.left, right: r.right, top: r.top + deja, bottom: r.bottom + deja };
  }

  function bloque(flotteurs, boutons, lift) {
    for (var i = 0; i < flotteurs.length; i++) {
      var f = {
        left: flotteurs[i].left,
        right: flotteurs[i].right,
        top: flotteurs[i].top - lift,
        bottom: flotteurs[i].bottom - lift
      };
      for (var j = 0; j < boutons.length; j++) {
        if (chevauche(f, boutons[j])) return true;
      }
    }
    return false;
  }

  /*
    Au repos on RETIRE nos declarations plutot que d'ecrire une valeur neutre :
    le widget retrouve alors exactement le comportement prevu par son
    application, animation d'appel comprise.
  */
  function poser(el, dy, efface) {
    if (!el) return;
    el.style.setProperty('transition', 'translate .18s ease, opacity .18s ease', 'important');
    if (dy) el.style.setProperty('translate', '0 ' + dy + 'px', 'important');
    else el.style.removeProperty('translate');
    if (efface) {
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    } else {
      el.style.removeProperty('opacity');
      el.style.removeProperty('pointer-events');
    }
  }

  function appliquer(n) {
    if (n === etat) return;
    etat = n;
    var dy = n === 1 ? -RELEVEMENT : 0;
    var efface = n === 2;
    poser(pastille(), dy, efface);
    poser(bulleChat(), dy, efface);
  }

  function evaluer() {
    planifie = false;

    if (window.innerWidth > LARGEUR_MAX) {
      appliquer(0);
      return;
    }

    var deja = etat === 1 ? RELEVEMENT : 0;
    var flotteurs = [];
    var p = pastille();
    var c = bulleChat();
    var r;
    if (p) {
      r = auRepos(p, deja);
      if (r) flotteurs.push(r);
    }
    if (c) {
      r = auRepos(c, deja);
      if (r) flotteurs.push(r);
    }

    var boutons = boutonsVisibles();
    var n;
    if (!flotteurs.length || !boutons.length) n = 0;
    else if (!bloque(flotteurs, boutons, 0)) n = 0;
    else if (!bloque(flotteurs, boutons, RELEVEMENT)) n = 1;
    else n = 2;

    /* On remonte tout de suite, on ne redescend qu'apres une courte pause. */
    if (n === 0 && etat > 0) {
      if (minuteur) return;
      minuteur = window.setTimeout(function () {
        minuteur = null;
        appliquer(0);
      }, RETOUR);
      return;
    }
    if (minuteur) {
      window.clearTimeout(minuteur);
      minuteur = null;
    }
    appliquer(n);
  }

  function planifier() {
    if (planifie) return;
    planifie = true;
    window.requestAnimationFrame(evaluer);
  }

  function demarrer() {
    planifier();
    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
    window.addEventListener('orientationchange', planifier);
    document.addEventListener('click', planifier, true);

    /*
      Les deux widgets sont injectes apres le chargement, et la barre d'achat
      collante bascule via son attribut data-stuck. On guette les deux, puis on
      allege l'observation au bout de 20 secondes pour ne rien laisser tourner.
    */
    if (!window.MutationObserver) return;
    var large = new MutationObserver(planifier);
    large.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      large.disconnect();
      var barre = document.querySelector('.sticky-add-to-cart__bar');
      if (barre) {
        new MutationObserver(planifier).observe(barre, {
          attributes: true,
          attributeFilter: ['data-stuck']
        });
      }
    }, 20000);

    var barre0 = document.querySelector('.sticky-add-to-cart__bar');
    if (barre0) {
      new MutationObserver(planifier).observe(barre0, {
        attributes: true,
        attributeFilter: ['data-stuck']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
